export default "__VITE_ASSET__Bpw2ux$x__"